<template>
  <div v-if="valueIsDefined">
    <span v-if="selectAll">{{ selectAll }}</span>
    <sample-shelf-badge
      v-else
      :status="params.value"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import SampleShelfBadge from '@/modules/grossingModule/views/components/SampleShelfBadge'

export default Vue.extend({
    name: 'SampleShelfRenderer',
    components: {
        SampleShelfBadge
    },
    computed: {
        valueIsDefined() {
            return this.params.value !== undefined
        },
        selectAll() {
            return this.params.value === this.$tc('component.agGrid.selectAll')
                ? this.params.value : null
        }
    }
})
</script>
